var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlRide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_5847",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_5847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2877 1.97095V2.43285C10.2877 2.85146 10.2877 3.27006 10.2877 3.68866C10.2877 3.87516 10.2877 3.87487 10.5097 3.87487C11.593 3.87487 12.6764 3.86765 13.7604 3.87487C15.2724 3.88699 16.6231 4.3079 17.7904 5.14511C18.9418 5.97105 19.6712 7.02651 19.986 8.29733C19.996 8.33832 20.0013 8.38047 20.0129 8.44687H19.8377C18.5553 8.44687 17.2726 8.44687 15.9899 8.44918C15.8751 8.44918 15.8154 8.41367 15.7537 8.33371C15.2638 7.68733 14.5701 7.3562 13.6798 7.35215C12.613 7.34725 11.5463 7.35417 10.4795 7.34927C10.3255 7.34927 10.2821 7.38882 10.2841 7.52075C10.2917 8.04039 10.2874 8.56004 10.2874 9.07968V9.25665L3.90625 5.61019L10.2877 1.97095Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.692 22.0291V21.5894C13.692 21.1564 13.687 20.7233 13.6946 20.2903C13.6969 20.1636 13.6512 20.126 13.5055 20.1269C12.4441 20.1315 11.3826 20.1344 10.3211 20.1269C8.36399 20.1154 6.71968 19.4834 5.42003 18.2042C4.69026 17.4874 4.22587 16.6511 3.99367 15.7157C3.98239 15.6701 3.97808 15.6233 3.9668 15.5558H4.14493C5.42169 15.5558 6.69912 15.5558 7.97555 15.5532C8.09464 15.5532 8.16097 15.5864 8.22732 15.6735C8.71493 16.3139 9.4049 16.645 10.2879 16.6505C11.3494 16.6574 12.4109 16.6522 13.4724 16.6505C13.6903 16.6505 13.691 16.6505 13.691 16.4588C13.691 15.901 13.691 15.3433 13.691 14.7451L20.0705 18.389L13.692 22.0291Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1219 9.67882C20.0317 10.0175 19.9664 10.3734 19.841 10.7129C19.2807 12.2306 18.1748 13.3521 16.5355 14.0617C15.3459 14.5765 13.9673 13.9953 13.6708 12.8726C13.5724 12.4965 13.6209 12.1026 13.8086 11.7532C13.9963 11.4038 14.3124 11.1188 14.7071 10.9433C15.3118 10.676 15.7463 10.2871 15.9815 9.73078C15.9934 9.70961 16.0109 9.69118 16.0325 9.67698C16.0541 9.66279 16.0792 9.65323 16.1059 9.64908C17.4206 9.64562 18.7353 9.64562 20.05 9.64908C20.0596 9.64822 20.0692 9.65601 20.1219 9.67882Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87891 14.3414C3.9691 13.6002 4.23281 12.883 4.65378 12.234C5.28643 11.2421 6.25419 10.4435 7.4259 9.94636C8.44061 9.50842 9.64275 9.85456 10.142 10.7258C10.6412 11.5971 10.2415 12.6312 9.23506 13.0755C8.64594 13.3353 8.22898 13.7233 7.99744 14.2637C7.98425 14.2868 7.965 14.3068 7.94126 14.3221C7.91751 14.3375 7.88995 14.3477 7.86079 14.3521C6.55649 14.3564 5.25187 14.3553 3.94658 14.3547C3.9236 14.3521 3.90095 14.3476 3.87891 14.3414Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlRide);
export default __webpack_public_path__ + "static/media/bl_ride.7811e3e58d033acbfbda1f3ae88ea304.svg";
export { ForwardRef as ReactComponent };